import api from "./api";

const LeaseTypeService = {
  getAll: async (pageNumber = 1, noOfRows = 20) => {
  const res = await api.get(
    `/leaseTypes/getAll?pageNumber=${pageNumber}&noOfRows=${noOfRows}`
  );
  return res.data.data || res.data;
},


  getById: async (id) => {
    const res = await api.get(`/leaseTypes/getById/${id}`);
    return res.data.data || res.data;
  },
  
  create: async (data) => {
    try {
      const res = await api.post("/leaseTypes/save", data);
      return res.data;      
    } catch (err) {
      return err.response?.data || {
        status: "error",
        message: "Failed to create lease type",
      };
    }
  },


  update: async (id, data) => {
    try {
      const res = await api.put(`/leaseTypes/update/${id}`, data);
      return res.data;      
    } catch (err) {
      return err.response?.data || {
        status: "error",
        message: "Failed to update lease type",
      };
    }
  },

  toggleStatus: async (id) => {
    const res = await api.put(`/leaseTypes/updateStatus/${id}`);
    return res.data;
  },

  getActive: async () => {
    const res = await api.get("/leaseTypes/getActive/list");
    return res.data;
  },

  // Delete lease type
  delete: async (id) => {
    const res = await api.delete(`/leaseTypes/${id}`);
    return res.data;
  },
};

export default LeaseTypeService;
